"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = require("../../src/internal/icon.tsx");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GoogleDoc24Icon = props => /*#__PURE__*/_react.default.createElement(_icon.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
}, props, {
  size: "medium"
}));
GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var _default = exports.default = GoogleDoc24Icon;